import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './styles.css';
import './index.css';
import App from './App';

Sentry.init({
  dsn: 'https://b280a6d9110b7f95c79499be2ca76945@o4511072139411456.ingest.us.sentry.io/4511184262660096',
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
